import { createAction, props } from '@ngrx/store';

import { type } from '@app/util/util';
import {
  ActivitiesResultsResponse,
  ActivitiesSearchResultsPayload,
  ActivitiesDetailPayload,
  ActivitiesDetailResponse
} from '@activities/activities-results/entities/activities-results';
import {
  ActivitiesFiltersPayload, ActivitiesFiltersResponse
} from '@activities/activities-results/entities/activities-filters';

export const fetchActivitiesResultsAction = createAction(
  type('[ActivitiesResults/API] Search activities Action'),
  props<{ payload: ActivitiesSearchResultsPayload }>()
);

export const fetchActivitiesResultsWithPaginationAction = createAction(
  type('[ActivitiesResults/API] Results activities with Pagination Action'),
  props<{ payload: ActivitiesSearchResultsPayload }>()
);

export const setActivitiesResultsCountPayloadAction = createAction(
  type('[ActivitiesResults/API] Set activities Results Count'),
  props<{ payload: number }>()
);

export const setActivitiesResultsPayloadAction = createAction(
  type('[ActivitiesResults/API] Set activities Results Payload'),
  props<{ payload: ActivitiesSearchResultsPayload }>()
);

export const fetchActivitiesResultsSuccessAction = createAction(
  type('[ActivitiesResults/API] Results activities Action Success'),
  props<{ response: ActivitiesResultsResponse }>()
);

export const fetchActivitiesFiltersAction = createAction(
  type('[ActivitiesResults/API] Fetch activities filters action'),
  props<{ payload: ActivitiesFiltersPayload }>()
);

export const fetchActivitiesFiltersSuccessAction = createAction(
  type('[ActivitiesResults/API] Fetch activities filters action success'),
  props<{ response: ActivitiesFiltersResponse }>()
);

export const fetchActivitiesResultsWithFilterAction = createAction(
  type('[ActivitiesResults/API] Results activities with Filter Action'),
  props<{ payload: ActivitiesSearchResultsPayload }>()
);

export const cleanActivitiesResultsAction = createAction(
  type('[ActivitiesResults/API] Clean activities results Action')
);

export const fetchActivitiesDetailAction = createAction(
  type('[ActivitiesResults/API] Detail activities Action'),
  props<{ payload: ActivitiesDetailPayload }>()
);

export const fetchActivitiesDetailSuccessAction = createAction(
  type('[ActivitiesResults/API] Detail activities Action Success'),
  props<{ response: ActivitiesDetailResponse }>()
);
